import React, { useEffect, useState } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useAuth } from '../lib/AuthContext'

function safeJobTagPath(token) {
  return `/job-tag/${encodeURIComponent(String(token || '').trim())}`
}

export default function JobTagRedirectPage() {
  const { token } = useParams()
  const navigate = useNavigate()
  const { user, loading, isActive, isSuperAdmin } = useAuth()
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false

    async function resolveJobTag() {
      if (loading || !user || (!isActive && !isSuperAdmin)) return
      const cleanToken = String(token || '').trim()
      if (!cleanToken) {
        setError('This job tag is missing its scan token.')
        return
      }

      const { data, error: lookupError } = await supabase
        .from('jobs')
        .select('id')
        .eq('job_tag_token', cleanToken)
        .maybeSingle()

      if (cancelled) return
      if (lookupError) {
        setError('Could not open this job tag. Please try again.')
        return
      }
      if (!data?.id) {
        setError('This job tag was not found, or you do not have access to it.')
        return
      }

      navigate(`/jobs?job=${encodeURIComponent(data.id)}`, { replace: true })
    }

    resolveJobTag()
    return () => { cancelled = true }
  }, [token, user, loading, isActive, isSuperAdmin, navigate])

  if (loading) {
    return (
      <div className="empty" style={{ minHeight: '100vh' }}>
        <span className="spinner" style={{ width: 24, height: 24 }} />
      </div>
    )
  }

  if (!user) {
    const next = safeJobTagPath(token)
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />
  }

  if (!isActive && !isSuperAdmin) return <Navigate to="/subscribe" replace />

  if (error) {
    return (
      <div className="empty" style={{ minHeight: '100vh', padding: 24 }}>
        <div className="empty-icon">QR</div>
        <p>{error}</p>
        <button className="btn btn-primary" onClick={() => navigate('/jobs', { replace: true })}>Go to Jobs</button>
      </div>
    )
  }

  return (
    <div className="empty" style={{ minHeight: '100vh' }}>
      <span className="spinner" style={{ width: 24, height: 24 }} />
      <p>Opening job tag...</p>
    </div>
  )
}
